import styled, { css } from 'styled-components/macro'

export const DragAndDropArea = styled.div<{ isError?: boolean }>`
  margin: 0;
  padding: 1.6rem;
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  ${(props) =>
    props.isError &&
    css`
      &::after {
        content: '';
        position: absolute;
        top: 0;
        width: 100%;
        height: 100%;
        background-color: red;
        z-index: ${(props) => props.theme.zIndex.negative};
      }
    `}
`

export const DragAndDropText = styled.h3`
  margin: 0;
  padding: 0;
  font-weight: ${(props) => props.theme.font.weight.regular};
  font-size: 1.6rem;
  line-height: 1.47;
  color: ${(props) => props.theme.color.textThird};
  text-align: center;
`

export const DragAndDropErrorText = styled(DragAndDropText)`
  color: ${(props) => props.theme.color.textPrimary};
`
